// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared chrome for the tools-panel palette dropdowns: the trigger card, the
   dropdown panel and the orange catalog footer.

   Intended as the single source of truth for every palette, but composed
   today by the BUILT-IN, AGENTS and MODELS palettes only - Datasets and
   Packages still carry their own near-identical copies. That is how the
   palettes drifted apart (the trigger kept the geometry of a narrow icon-only
   rail the other two had already left, and this header centred its title while
   both peers left-aligned theirs).

   Until the other two are migrated onto it, DatasetsPaletteDropdown.module.css
   is the reference: when a value here disagrees with it, this file is the one
   that is wrong. Palettes keep their own palette-specific classes (sort toggle,
   package toolbar, agent row chips, …) local; do not add those here. */

/* ── layout ──────────────────────────────────────────────────────────────── */
/* Column, not row: the trigger is the only thing in flow, and .panel below is
   lifted out of the flow entirely. A row here would put the open panel *beside*
   the trigger inside the rail, which is what made the rail jump from ~56px to
   ~444px wide whenever this palette opened. Matches
   DatasetsPaletteDropdown.module.css and ToolsMenuPackagePalette.module.css. */
.fGAKevrFyfBnHHw9rnVN {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex-shrink: 0;
  /* The palette dock (.paletteDock) is pointer-events: none so clicks fall
     through its gaps to the canvas; re-enable events on each palette's subtree. */
  pointer-events: none;
}

.fGAKevrFyfBnHHw9rnVN > * {
  pointer-events: auto;
}

/* No width: the column stretches to the rail, so this trigger is the same size
   as the Node and Data ones stacked above it. The 56px that used to be pinned
   here dates from when this palette was a narrow icon-only strip; the rail
   redesign widened the other two and this shell was never brought along, which
   left the Agent Catalog trigger half the width and, because the label then
   wrapped, nearly twice the height of its peers (56x94 against their 102x50). */
.s8Rm5tRHWah2nJaN5xgX {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 4px;
  flex-shrink: 0;
}

/* ── trigger card ────────────────────────────────────────────────────────── */
/* \`width: 100%\` + \`box-sizing: border-box\` + 8px padding, matching
   DatasetsPaletteDropdown and ToolsMenuPackagePalette exactly. The old
   \`min-width: 56px\` / \`10px 8px\` pair belonged to the narrow rail this shell
   was written for. */
.UpzVYukjVJs_4ciKTNiN {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  width: 100%;
  box-sizing: border-box;
  padding: 8px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 5px;
  background-color: #1e1f23;
  color: #fbfcf6;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease, background-color 0.15s ease;
}

.UpzVYukjVJs_4ciKTNiN:hover {
  background-color: #2c2d32;
}

/* Icon, count and chevron share one row, with the label beneath - two rows, not
   four stacked children. Both peers do exactly this
   (DatasetsPaletteDropdown.module.css \`.triggerTop\`,
   ToolsMenuPackagePalette.module.css \`.packagePaletteTriggerTop\`), and it is
   what makes all three triggers the same 50px height. */
.FIsoBYxJsSIOf64XP0zY {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.LfoUoR7qER_v7NbdxGHQ {
  border-color: rgba(251, 170, 105, 0.85);
  color: #fbaa69;
}

.g8j5V5XKof_2JXzCHQ42 {
  font-size: 1.25em;
}

.SlAOMflbWZHoGCcsId7Q {
  color: inherit;
  font-size: 8px;
  font-weight: 700;
  letter-spacing: 0.6px;
  line-height: 1;
  text-transform: uppercase;
}

.sU3SNJebnGsPx2ICGN4i {
  border-radius: 8px;
  background: rgba(251, 170, 105, 0.25);
  color: #fbfcf6;
  padding: 1px 6px;
  font-size: 10px;
  font-weight: 700;
  line-height: 1.2;
}

.LfoUoR7qER_v7NbdxGHQ .sU3SNJebnGsPx2ICGN4i {
  background-color: rgba(251, 170, 105, 0.35);
}

.KA7Ej0IXKC0teF9J0AAd {
  font-size: 10px;
  opacity: 0.85;
}

/* ── dropdown panel ──────────────────────────────────────────────────────── */
/* Absolutely positioned against #tools-palette-dock (the only positioned
   ancestor, being \`position: fixed\`) so the panel opens beside the built-in rail
   without widening it, and starts level with the top of the rail rather than at
   its own trigger's y.

   This was missed when the Agent Catalog joined the rail: the two peers were
   converted in 9f81f1d6, and 3fa39bf5 added Agents by touching only .tsx, so
   this shell kept the pre-rail in-flow layout. That cost two things - the rail
   widened to ~444px whenever Agents opened, and the panel hung down from a
   trigger already near the fold, putting "Browse Agent Catalog +" off screen at
   1280x720. */
.HSa5eAaN0bSUQNRehcCC {
  position: absolute;
  top: 0;
  left: 100%;
  margin-left: 10px;
  width: min(380px, calc(100vw - 120px));
  min-height: 0;
  max-height: calc(100vh - 170px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 5px;
  background-color: #1e1f23;
  box-shadow: 6px 10px 28px rgba(0, 0, 0, 0.45);
  color: #fbfcf6;
}

/* flex-start, not center: both peers pin the title to the same 10px left inset
   (DatasetsPaletteDropdown.module.css \`.panelHeader\`,
   ToolsMenuPackagePalette.module.css \`.packagePaletteToolbar\`, whose comment
   says it deliberately matches the dataset header). Centred here, the title
   jumped ~150px sideways when you switched between the three palettes.
   \`justify-content\` is what moves it - the title below is a shrink-to-fit flex
   item, so its own \`text-align\` has no rendered effect either way. */
.I04xMVz8qXZCvTAcKvng {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  min-height: 34px;
  padding: 0 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.jNE_NylPAbSmWZEOMx3G {
  color: rgba(255, 255, 255, 0.55);
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.8px;
  line-height: 1.2;
  /* Matches both peers. Inert while the title shrink-wraps its text; it starts
     mattering if the label ever wraps or the item grows. */
  text-align: left;
  text-transform: uppercase;
}

.ls2XpFafnubFmLeLxXNT {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 8px 8px 10px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  scrollbar-color: rgba(255, 255, 255, 0.18) transparent;
  scrollbar-width: thin;
}

.ls2XpFafnubFmLeLxXNT::-webkit-scrollbar {
  width: 5px;
}

.ls2XpFafnubFmLeLxXNT::-webkit-scrollbar-track {
  background: transparent;
}

.ls2XpFafnubFmLeLxXNT::-webkit-scrollbar-thumb {
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.14);
}

.ls2XpFafnubFmLeLxXNT:hover::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.22);
}

.BIGCNpRcgOpqI5eRKEbK {
  border-radius: 4px;
  color: rgba(251, 252, 246, 0.62);
  padding: 10px 6px;
  font-size: 11px;
  line-height: 1.35;
  text-align: center;
}

/* ── orange "Browse … Catalog +" footer ─────────────────────────────────── */
.RpVcTk28EGGGPRyFSJPq {
  flex-shrink: 0;
  padding: 8px 10px 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  background-color: #1e1f23;
  box-shadow: 0 -6px 12px rgba(0, 0, 0, 0.18);
}

.Q6pgfuMU6mR8Scg2uRSm {
  width: 100%;
  box-sizing: border-box;
  min-height: 32px;
  border: none;
  border-radius: 4px;
  background-color: #fbaa69;
  color: #1e1f23;
  padding: 8px 10px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.4px;
  line-height: 1.2;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.Q6pgfuMU6mR8Scg2uRSm:hover {
  background-color: #fb9a4f;
}

.Q6pgfuMU6mR8Scg2uRSm:focus-visible {
  outline: 2px solid rgba(251, 170, 105, 0.85);
  outline-offset: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/components/menus/nodes/paletteShell/paletteShell.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;uEAauE;;AAEvE,+EAA+E;AAC/E;;;;+EAI+E;AAC/E;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;EACd;kFACgF;EAChF,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;;;;gFAKgF;AAChF;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,QAAQ;EACR,cAAc;AAChB;;AAEA,+EAA+E;AAC/E;;;qBAGqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,2CAA2C;EAC3C,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,kFAAkF;AACpF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;wDAIwD;AACxD;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA,+EAA+E;AAC/E;;;;;;;;;;cAUc;AACd;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,iBAAiB;EACjB,sCAAsC;EACtC,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,yBAAyB;EACzB,6CAA6C;EAC7C,cAAc;AAChB;;AAEA;;;;;;qEAMqE;AACrE;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,gCAAgC;EAChC,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB;2DACyD;EACzD,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,sDAAsD;EACtD,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,8EAA8E;AAC9E;EACE,cAAc;EACd,sBAAsB;EACtB,+CAA+C;EAC/C,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;AACrB","sourcesContent":["/* Shared chrome for the tools-panel palette dropdowns: the trigger card, the\n   dropdown panel and the orange catalog footer.\n\n   Intended as the single source of truth for every palette, but composed\n   today by the BUILT-IN, AGENTS and MODELS palettes only - Datasets and\n   Packages still carry their own near-identical copies. That is how the\n   palettes drifted apart (the trigger kept the geometry of a narrow icon-only\n   rail the other two had already left, and this header centred its title while\n   both peers left-aligned theirs).\n\n   Until the other two are migrated onto it, DatasetsPaletteDropdown.module.css\n   is the reference: when a value here disagrees with it, this file is the one\n   that is wrong. Palettes keep their own palette-specific classes (sort toggle,\n   package toolbar, agent row chips, …) local; do not add those here. */\n\n/* ── layout ──────────────────────────────────────────────────────────────── */\n/* Column, not row: the trigger is the only thing in flow, and .panel below is\n   lifted out of the flow entirely. A row here would put the open panel *beside*\n   the trigger inside the rail, which is what made the rail jump from ~56px to\n   ~444px wide whenever this palette opened. Matches\n   DatasetsPaletteDropdown.module.css and ToolsMenuPackagePalette.module.css. */\n.root {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  flex-shrink: 0;\n  /* The palette dock (.paletteDock) is pointer-events: none so clicks fall\n     through its gaps to the canvas; re-enable events on each palette's subtree. */\n  pointer-events: none;\n}\n\n.root > * {\n  pointer-events: auto;\n}\n\n/* No width: the column stretches to the rail, so this trigger is the same size\n   as the Node and Data ones stacked above it. The 56px that used to be pinned\n   here dates from when this palette was a narrow icon-only strip; the rail\n   redesign widened the other two and this shell was never brought along, which\n   left the Agent Catalog trigger half the width and, because the label then\n   wrapped, nearly twice the height of its peers (56x94 against their 102x50). */\n.column {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n/* ── trigger card ────────────────────────────────────────────────────────── */\n/* `width: 100%` + `box-sizing: border-box` + 8px padding, matching\n   DatasetsPaletteDropdown and ToolsMenuPackagePalette exactly. The old\n   `min-width: 56px` / `10px 8px` pair belonged to the narrow rail this shell\n   was written for. */\n.trigger {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  width: 100%;\n  box-sizing: border-box;\n  padding: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 5px;\n  background-color: #1e1f23;\n  color: #fbfcf6;\n  cursor: pointer;\n  transition: border-color 0.15s ease, color 0.15s ease, background-color 0.15s ease;\n}\n\n.trigger:hover {\n  background-color: #2c2d32;\n}\n\n/* Icon, count and chevron share one row, with the label beneath - two rows, not\n   four stacked children. Both peers do exactly this\n   (DatasetsPaletteDropdown.module.css `.triggerTop`,\n   ToolsMenuPackagePalette.module.css `.packagePaletteTriggerTop`), and it is\n   what makes all three triggers the same 50px height. */\n.triggerTop {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n}\n\n.triggerOpen {\n  border-color: rgba(251, 170, 105, 0.85);\n  color: #fbaa69;\n}\n\n.triggerIcon {\n  font-size: 1.25em;\n}\n\n.triggerLabel {\n  color: inherit;\n  font-size: 8px;\n  font-weight: 700;\n  letter-spacing: 0.6px;\n  line-height: 1;\n  text-transform: uppercase;\n}\n\n.triggerCount {\n  border-radius: 8px;\n  background: rgba(251, 170, 105, 0.25);\n  color: #fbfcf6;\n  padding: 1px 6px;\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n.triggerOpen .triggerCount {\n  background-color: rgba(251, 170, 105, 0.35);\n}\n\n.triggerChevron {\n  font-size: 10px;\n  opacity: 0.85;\n}\n\n/* ── dropdown panel ──────────────────────────────────────────────────────── */\n/* Absolutely positioned against #tools-palette-dock (the only positioned\n   ancestor, being `position: fixed`) so the panel opens beside the built-in rail\n   without widening it, and starts level with the top of the rail rather than at\n   its own trigger's y.\n\n   This was missed when the Agent Catalog joined the rail: the two peers were\n   converted in 9f81f1d6, and 3fa39bf5 added Agents by touching only .tsx, so\n   this shell kept the pre-rail in-flow layout. That cost two things - the rail\n   widened to ~444px whenever Agents opened, and the panel hung down from a\n   trigger already near the fold, putting \"Browse Agent Catalog +\" off screen at\n   1280x720. */\n.panel {\n  position: absolute;\n  top: 0;\n  left: 100%;\n  margin-left: 10px;\n  width: min(380px, calc(100vw - 120px));\n  min-height: 0;\n  max-height: calc(100vh - 170px);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 5px;\n  background-color: #1e1f23;\n  box-shadow: 6px 10px 28px rgba(0, 0, 0, 0.45);\n  color: #fbfcf6;\n}\n\n/* flex-start, not center: both peers pin the title to the same 10px left inset\n   (DatasetsPaletteDropdown.module.css `.panelHeader`,\n   ToolsMenuPackagePalette.module.css `.packagePaletteToolbar`, whose comment\n   says it deliberately matches the dataset header). Centred here, the title\n   jumped ~150px sideways when you switched between the three palettes.\n   `justify-content` is what moves it - the title below is a shrink-to-fit flex\n   item, so its own `text-align` has no rendered effect either way. */\n.panelHeader {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  min-height: 34px;\n  padding: 0 10px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.title {\n  color: rgba(255, 255, 255, 0.55);\n  font-size: 9px;\n  font-weight: 700;\n  letter-spacing: 0.8px;\n  line-height: 1.2;\n  /* Matches both peers. Inert while the title shrink-wraps its text; it starts\n     mattering if the label ever wraps or the item grows. */\n  text-align: left;\n  text-transform: uppercase;\n}\n\n.scroll {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 8px 8px 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  scrollbar-color: rgba(255, 255, 255, 0.18) transparent;\n  scrollbar-width: thin;\n}\n\n.scroll::-webkit-scrollbar {\n  width: 5px;\n}\n\n.scroll::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.scroll::-webkit-scrollbar-thumb {\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.14);\n}\n\n.scroll:hover::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.22);\n}\n\n.sectionEmpty {\n  border-radius: 4px;\n  color: rgba(251, 252, 246, 0.62);\n  padding: 10px 6px;\n  font-size: 11px;\n  line-height: 1.35;\n  text-align: center;\n}\n\n/* ── orange \"Browse … Catalog +\" footer ─────────────────────────────────── */\n.footer {\n  flex-shrink: 0;\n  padding: 8px 10px 10px;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  background-color: #1e1f23;\n  box-shadow: 0 -6px 12px rgba(0, 0, 0, 0.18);\n}\n\n.catalogButton {\n  width: 100%;\n  box-sizing: border-box;\n  min-height: 32px;\n  border: none;\n  border-radius: 4px;\n  background-color: #fbaa69;\n  color: #1e1f23;\n  padding: 8px 10px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.4px;\n  line-height: 1.2;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n}\n\n.catalogButton:hover {\n  background-color: #fb9a4f;\n}\n\n.catalogButton:focus-visible {\n  outline: 2px solid rgba(251, 170, 105, 0.85);\n  outline-offset: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `fGAKevrFyfBnHHw9rnVN`,
	"column": `s8Rm5tRHWah2nJaN5xgX`,
	"trigger": `UpzVYukjVJs_4ciKTNiN`,
	"triggerTop": `FIsoBYxJsSIOf64XP0zY`,
	"triggerOpen": `LfoUoR7qER_v7NbdxGHQ`,
	"triggerIcon": `g8j5V5XKof_2JXzCHQ42`,
	"triggerLabel": `SlAOMflbWZHoGCcsId7Q`,
	"triggerCount": `sU3SNJebnGsPx2ICGN4i`,
	"triggerChevron": `KA7Ej0IXKC0teF9J0AAd`,
	"panel": `HSa5eAaN0bSUQNRehcCC`,
	"panelHeader": `I04xMVz8qXZCvTAcKvng`,
	"title": `jNE_NylPAbSmWZEOMx3G`,
	"scroll": `ls2XpFafnubFmLeLxXNT`,
	"sectionEmpty": `BIGCNpRcgOpqI5eRKEbK`,
	"footer": `RpVcTk28EGGGPRyFSJPq`,
	"catalogButton": `Q6pgfuMU6mR8Scg2uRSm`
};
export default ___CSS_LOADER_EXPORT___;
